/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListEstablishmentsQueryResponse, ListEstablishmentsPathParams, ListEstablishmentsQueryParams, ListEstablishments400, ListEstablishments401, ListEstablishments403, ListEstablishments404, ListEstablishments409, ListEstablishments500 } from "../../types/establishmentController/ListEstablishments.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListEstablishmentsUrl(organizationId: ListEstablishmentsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/establishments/` as const }
  return res
}

/**
 * @summary List establishments
 * {@link /api/organizations/:organizationId/establishments/}
 */
export async function listEstablishments(organizationId: ListEstablishmentsPathParams["organizationId"], params?: ListEstablishmentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListEstablishmentsQueryResponse, ResponseErrorConfig<ListEstablishments400 | ListEstablishments401 | ListEstablishments403 | ListEstablishments404 | ListEstablishments409 | ListEstablishments500>, unknown>({ method : "GET", url : getListEstablishmentsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}